export default "__VITE_ASSET__ef3bad41__"